import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const LoaderContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: ${theme.spacing.xLarge} 0;
`;

export const LoadingErrorContainer = styled.div`
  width: 100%;
  padding: ${theme.spacing.small} ${theme.spacing.xSmall};
`;
